import React from 'react';

import { PLATFORM_ICONS } from '@domain/platform/platform-icons.constants';
import { Cell } from '@shared/components/tables/column-components/table.types';
import {
    CampaignNameFieldWrapper,
} from './campaign-name-field.styles';
import { CampaignNameFieldIconComponent } from './campaign-name-field-icon';
import { CampaignNameFieldTextComponent } from './campaign-name-field-text';
import { CampaignRow } from '../../campaign-table.types';

interface CampaignNameFieldProps {
    cell: Cell<CampaignRow>
}

export const CampaignNameField = ({
    cell,
}: CampaignNameFieldProps) => {
    const { row } = cell;
    const { original } = row;
    const {
        name, platform,
    } = original;

    const Icon = PLATFORM_ICONS[platform];

    return (
        <CampaignNameFieldWrapper>
            {
                platform ? (
                    <CampaignNameFieldIconComponent
                        Icon={Icon}
                        platform={platform}
                    />
                ) : ''
            }
            <CampaignNameFieldTextComponent title={name} />
        </CampaignNameFieldWrapper>
    );
};
